import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchOptimisticPatchDeleteOrganisation } from './dispatch-optimistic-patch';
import { DeleteOrganisationQueryArg } from '../types/query-arg';

export const handleResultDeleteOrganisation: QueryHandler<
  DeleteOrganisationQueryArg,
  void
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch } = dispatchOptimisticPatchDeleteOrganisation(queryArg, {
    dispatch,
    getState,
  });

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
